export const endpoint = '/me';
export const endpointClaims = '/me/claims';
export const endpointIsVerified = '/me/verified';
export const endpointRequestVerification = '/me/verify';
export const endpointClearProfilePhoto = '/me/photo';
export const endpointProfilePhoto = '/me/photo/$value';
export const endpointUserSubscriptions = '/me/subscriptions';
